import { SurveyTemplate } from '../state/types';

// eslint-disable-next-line @altermaind/you-shall-not-pass
export const it = {
  surveys: {
    pageTitle: 'Assessment',
    emptyStateNoPeople: {
      title: 'Soft skills assessment',
      titleHardSkills: 'Hard skills assessment',
      descriptionLine1: 'Non sono presenti anagrafiche con profilo completo.',
      descriptionLine2:
        'Per inviare l’assessment è necessario prima censire gli utenti dell’azienda nella sezione !{CTA}!.',
      ctaLabel: 'Anagrafiche',
    },
    emptyStateNoCampaigns: {
      title: 'Soft skills assessment',
      descriptionLine1:
        'Hai caricato {{countPeople}} anagrafiche complete, idonee a ricevere il questionario, ma non hai ancora effettuato l’invio.\nClicca su "!{SEND}!" per iniziare a raccogliere i risultati sulle {{templateName}} della tua azienda.\nLo stato di visibilità dei risultati per manager e dipendenti potrà essere modificato dopo l\'invio dell\'assessment.',
      ctaLabel: 'Invia assessment',
      alertBadge:
        'Il modello è in fase di validazione scientifica e mostra un livello di affidabilità consistente, soprattutto nella visualizzazione aggregata per team e dipartimenti',
      goToGuideCta: 'guida',
    },
    usefullInformations: {
      title: 'Materiali utili',
      model: {
        title: 'Scopri come funziona l’assessment',
        description: 'Approfondisci logiche, punteggi \ne criteri che danno forma ai risultati.',
        buttonLabel: 'Vai alla guida',
      },
      boxTutorial: {
        title: 'Tutorial',
        description:
          "Scopri come inviare l'assessment e visualizzare i risultati dell'organizzazione",
        buttonLabel: 'Guarda ora',
      },
      simulation: {
        title: 'Fai una simulazione',
        description:
          "Prova la compilazione e vivi in prima persona\n l'esperienza dei tuoi dipendenti.",
        buttonLabel: 'Scopri di più',
      },
    },
    campaign: {
      setVisibilityDialog: {
        title: 'Gestione visibilità risultati',
        description:
          'Decidi se i dipendenti possono visualizzare i risultati del proprio assessment subito dopo la compilazione.',
        labelToggle: 'Visibilità risultati',
        valueOnToggle: 'Attiva',
        valueOffToggle: 'Non attiva',
        persons: 'persone',
        person: 'persona',
        alert: {
          visibleWithResponses:
            'Disattivando la visibilità, solo gli amministratori potranno accedere ai risultati. I dipendenti che avevano già visualizzato i risultati ({{totalCompletedResponses}}) non potranno più accedervi. Valuta attentamente questa azione per evitare confusione o aspettative disattese.',
          hidden:
            'Attivando la visibilità, i dipendenti potranno vedere i propri risultati direttamente dalla homepage appena completato l’assessment. Abilita questa opzione solo se desideri che le informazioni siano subito accessibili.',
          visible:
            'Disattivando la visibilità, solo gli amministratori potranno accedere ai risultati. Assicurati di mantenere questa impostazione se vuoi impedire ai dipendenti di visualizzare le informazioni.',
        },
        buttons: {
          cancel: 'Annulla',
          save: 'Salva',
        },
      },
      reminderDialog: {
        title: 'Invia reminder',
        description: {
          [SurveyTemplate.HardSkillAssessment]:
            "Il reminder sarà inviato a {{pending}} utenti che risultano non aver ancora completato l'hard skills assessment",
          [SurveyTemplate.SoftSkillAssessment]:
            'Il reminder sarà inviato a {{pending}} utenti che risultano non aver ancora completato il soft skills assessment',
        },
        lastSendWarning:
          "L'ultimo reminder è stato inviato !{BOLD}!: sei sicuro di volerne inviare un altro?",
        lastSendWarningBold: 'meno di 48 ore fa',
        confirmMessage: "Desideri procedere con l'invio del reminder?",
        tabs: {
          summary: 'Riepilogo',
          viewPeople: 'Vedi persone',
        },
        table: {
          name: 'Nome',
          role: 'Ruolo',
          mail: 'Mail',
        },
        buttons: {
          cancel: 'Annulla',
          send: 'Invia',
        },
        alert: 'Riepilogo: {{total}} persone riceveranno il reminder',
        unknownDepartment: 'Non assegnato',
      },
      status: {
        notVisible: {
          title: 'Condivisione dei risultati disattivata',
          description:
            'Al momento, i risultati dell’assessment non verranno mostrati ai dipendenti. Se vuoi permettere loro di visualizzarli al termine della compilazione, modifica le impostazioni di visibilità',
        },
        visible: {
          title: 'Condivisione dei risultati attivata',
          description:
            'Al momento, i risultati dell’assessment sono visibili ai dipendenti al termine della compilazione. Se vuoi limitarne la visualizzazione, modifica le impostazioni di visibilità.',
        },
        cta: 'Gestisci visibilità',
      },
      noData: 'Nessun dato da visualizzare',
      description:
        'Visualizza analisi, risultati per dipartimento e insights della tua organizzazione',
      results: {
        title: 'Risposte',
        description: 'Su {{total}} assessment inviati',
        completionRate: 'Tasso completamento',
        completed: 'Completati',
        notCompleted: 'Da completare',
        viewResults: 'Visualizza risultati',
        sendReminder: 'Invia reminder',
        alertLabel:
          'Non sono ancora presenti risultati: la dashboard sarà visibile solo quando sarà raccolta almeno una risposta',
      },
      coverage: {
        title: 'Assessment inviati',
        description: 'Su {{total}} profili validi disponibili',
        sendSurvey: "Invia l'assessment",
        totalSended: 'Inviati',
        notSended: 'Non inviati',
        completionRate: 'Tasso copertura',
        alertLabel:
          'L’assessment può essere inviato solo a profili completi. Se alcuni risultano incompleti, correggili in !{CTA}!.',
        ctaLabel: 'Anagrafiche',
      },
    },
    sendSurvey: {
      title: 'Invia {{templateName}} assessment',
      stepTemplates: {
        description: 'Scegli un assessment',
        buttons: {
          continue: 'Continua',
        },
      },
      stepChooser: {
        description: 'Ciao {{name}}! A chi vuoi inviare l’assessment?',
        all: {
          title: 'Invia a tutti',
          description: {
            single: '{{total}} persona',
            plural: '{{total}} persone',
          },
          descriptionHard: {
            single: "{{total}} persona non ha ancora ricevuto l'hard skills assessment",
            plural: "{{total}} persone non hanno ancora ricevuto l'hard skills assessment",
          },
          descriptionSoft: {
            single: '{{total}} persona non ha ancora ricevuto il soft skills assessment',
            plural: '{{total}} persone non hanno ancora ricevuto il soft skills assessment',
          },
        },
        departments: {
          title: 'Seleziona dall’organizzazione',
          description: 'Scegli dipartimenti specifici',
        },
        employer: {
          title: 'Seleziona individui',
          description: 'Cerca e seleziona profili specifici',
        },
        buttons: {
          back: 'Indietro',
        },
      },
      stepRecapAll: {
        title: '{{name}} Assessment',
        totalsSelected: 'Destinatari totali:',
        selectedDepartmentsLabel: 'Dipartimenti selezionati ({{count}}):',
        selectedDeparments: '{{totalDepartments}} dipartimenti selezionati:',
        unknownDepartment: 'Non assegnato',
        alertBadge: {
          label:
            "!{TOTAL_NEW_INVITED}! riceveranno un assessment per la prima volta. L'invio renderà attive le loro licenze. In base alla subscription attivata, !{SUBSCRIPTION_AMOUNT_NOTICE}!. Trova maggiori dettagli sul tuo piano nella sezione !{SETTINGS_LINK}!. Consulta il contratto per ulteriori specifiche.",
          totalInvited: '{{totalNewInvited}} destinatari',
          subscriptionAmountNotice:
            'l’importo del tuo abbonamento potrebbe subire delle variazioni',
          settingsLink: 'Impostazioni / Piano',
        },
        description: 'Ecco il riepilogo del tuo invio',
        buttons: {
          back: 'Indietro',
          send: 'Invia',
        },
      },
      stepListEmployees: {
        description: 'Cerca e seleziona le persone specifiche che vuoi includere',
        descriptionForEmployeeOfDepartment:
          'Se necessario rimuovi gli utenti dai dipartimenti prima di inviare.',
        searchPlaceholder: 'Cerca per nome o cognome',
        buttons: {
          back: 'Indietro',
          continue: 'Continua',
        },
        table: {
          name: 'Nome',
          email: 'Email',
          role: 'Ruolo',
          department: 'Dipartimento',
          lastCompletedPeriod: 'Ultimo questionario completato',
        },
      },
      stepRecapDepartments: {
        description:
          'Seleziona i dipartimenti. Clicca sui dipartimenti che vuoi includere.\nPuoi selezionarne quanti ne vuoi.',
        manager: 'Responsabile: ',
        team: 'Team: ',
        unknownDepartment: 'Non assegnato',
        buttons: {
          back: 'Indietro',
          continue: 'Continua',
          viewPeople: 'Vedi persone',
        },
        alert: {
          info: '!{TOTAL_SELECTED_DEPARTMENTS}! Totale destinatari: {{totalEmployees}} persone',
          selectedDeparments: '{{totalDepartments}} dipartimenti selezionati:',
        },
      },
      stepLastConfirm: {
        description:
          "L'invio del questionario avvia l’assessment delle soft skills, con l’obiettivo di restituire una fotografia chiara dei punti di forza e delle aree di sviluppo dell’organizzazione. Una volta inviato, i partecipanti ricevono l’invito in piattaforma e dopo la compilazione, i risultati saranno immediatamente disponibili per dipendenti e manager. In automatico si attivano anche billing ed erogazione dei crediti.",
        buttons: {
          back: 'Indietro',
          confirm: 'Conferma',
        },
        sent: {
          title: 'Assessment inviato!',
          description: {
            single: 'L’assessment {{templateName}} è stato inviato a {{count}} persona.',
            plural: 'L’assessment {{templateName}} è stato inviato a {{count}} persone.',
          },
          visibility: {
            title: 'Condivisione dei risultati disattivata',
            description:
              'Al momento, i risultati dell’assessment non verranno mostrati ai dipendenti. Se vuoi permettere loro di visualizzarli al termine della compilazione, modifica le impostazioni di visibilità',
            buttonLabel: 'Gestisci visibilità',
          },
          isVisible: {
            title: 'Condivisione dei risultati attivata',
            description:
              'Al momento, i risultati dell’assessment sono visibili ai dipendenti al termine della compilazione. Se vuoi limitarne la visualizzazione, modifica le impostazioni di visibilità.',
            buttonLabel: 'Gestisci visibilità',
          },
          saveVisibility: {
            description:
              'Decidi se i dipendenti possono visualizzare i risultati del proprio assessment subito dopo la compilazione.',
            labelToggle: 'Visibilità risultati',
            alert:
              'Attivando la visibilità, i dipendenti potranno vedere i propri risultati direttamente dalla homepage appena completato l’assessment. Abilita questa opzione solo se desideri che le informazioni siano subito accessibili.',
          },
        },
      },
    },
    details: {
      stats: {
        title: 'Risultati',
        description: {
          label:
            'I dati si riferiscono agli utenti dell’organizzazione che hanno completato il questionario. La base di analisi è costituita da {{count}}',
          single: 'utente',
          plural: 'utenti',
        },
        tabs: {
          tab1: 'Organizzazione',
          tab2: 'Dipartimenti',
        },
        tabOrganization: {
          title: 'Punteggio medio per {{currentName}}',
          description:
            'Il grafico riporta i punteggi medi (scala 0-7) sulle {{metricsCount}} {{currentName}}, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
          insignBox: {
            title: 'Insight',
            proTitle: 'Punti di forza',
            conTitle: 'Punti di debolezza',
          },
          downloadAnswerGuide: 'Scarica Guida alle risposte',
          distributionBox: {
            title: 'Distribuzione dei punteggi per skill',
            description:
              'La distribuzione mostra la percentuale di utenti collocati nei tre livelli di competenza per ciascuna skill.',
          },
        },
        tabDepartments: {
          distributionBox: {
            title: 'Distribuzione risposte per dipartimento',
            description:
              "Il grafico mostra il numero e la percentuale di utenti che hanno completato il questionario {{currentName}} all'interno di ciascun dipartimento.",
            goToDepartments:
              'Vuoi avere delle analisi più approfondita? Vai su Dipartimenti, ed esplora il dipartimento di interesse',
            downloadAnswerGuide: 'Scarica Guida alle risposte',
          },
          distributionBySkillBox: {
            title: 'Distribuzione punteggi per skill ',
            description:
              'La distribuzione mostra la percentuale di utenti del dipartimento collocati nei tre livelli di competenza per ciascuna skill.',
          },
          overallBox: {
            title: 'Confronto punteggi tra dipartimenti',
            subTitle: 'Punteggio medio per dipartimento',
            description:
              'Il grafico confronta i punteggi medi (scala 0-7) di ciascun dipartimento con la media complessiva aziendale. Permette di identificare i dipartimenti che si posizionano sopra o sotto la media organizzativa.',
            highValue: {
              title: 'Dipartimento con punteggio più alto in {{metric}}',
              score: 'Punteggio medio: ',
            },
            lowerValue: {
              title: 'Dipartimento con punteggio più basso in {{metric}}',
              score: 'Punteggio medio: ',
            },
            tooltipValue: 'Punteggio: ',
            tooltipTotal: 'Tot. persone: ',
          },
          departments: {
            title: 'Scopri di più sui dipartimenti',
            description: 'Il punto di forza del dipartimento è la metrica {{strength}}',
            viewDetails: 'Vai al dipartimento',
            showMore: 'Scopri di più',
            showLess: 'Mostra meno',
          },
        },
      },
    },
    tutorial: {
      softSkills: {
        title: 'Gestisci l’assessment sulle soft skills',
        slides: {
          slide1: {
            title: 'Esplora l’assessment',
            description:
              'Prova una simulazione dell’assessment per comprendere come funziona il modello, esplorare le domande e vedere un esempio di risultato.\nLa simulazione non salva alcun dato e non influisce sulle metriche reali.',
          },
          slide2: {
            title: 'Invia ai destinatari',
            description:
              'L’assessment può essere inviato solo a profili completi.\nÈ possibile scegliere se inviarlo a singoli profili, a un dipartimento oppure all’intera organizzazione.',
          },
          slide3: {
            title: 'Gestione visibilità dei risultati',
            description:
              'Decidi se i dipendenti possono visualizzare i risultati del proprio assessment subito dopo la compilazione. Questa impostazione può essere modificata in qualsiasi momento.\nAttenzione: se decidi di nascondere i risultati dopo averli resi visibili, i dipendenti che li avevano già visualizzati non potranno più accedervi.',
          },
          slide4: {
            title: 'Monitora l’andamento',
            description:
              'Dopo l’invio puoi monitorare il tasso di copertura e di completamento, e inviare reminder a chi non ha ancora risposto.',
          },
          slide5: {
            title: 'Dai uno sguardo ai risultati',
            description:
              'Accedi alla dashboard per visualizzare i dati aggregati: punteggi medi dell’organizzazione e panoramica per dipartimento. Troverai valori medi (scala 0–7) sulle 6 soft skills, distribuzioni per livello e insight sui punti di forza e le aree di miglioramento.',
          },
        },
      },
      hardSkills: {
        title: 'Gestisci l’assessment sulle hard skills',
        slides: {
          slide1: {
            title: 'Esplora l’assessment',
            description:
              'Prova una simulazione dell’assessment per comprendere come funziona il modello, esplorare le domande e vedere un esempio di risultato.\nLa simulazione non salva alcun dato e non influisce sulle metriche reali.',
          },
          slide2: {
            title: 'Invia ai destinatari',
            description:
              'L’assessment può essere inviato solo a profili completi. È possibile scegliere se inviarlo a singoli profili, a un dipartimento oppure all’intera organizzazione.',
          },
          slide3: {
            title: 'Gestione visibilità dei risultati',
            description:
              'Decidi se i dipendenti possono visualizzare i risultati del proprio assessment subito dopo la compilazione. Questa impostazione può essere modificata in qualsiasi momento. Attenzione: se decidi di nascondere i risultati dopo averli resi visibili, i dipendenti che li avevano già visualizzati non potranno più accedervi.',
          },
          slide4: {
            title: 'Monitora l’andamento',
            description:
              'Dopo l’invio puoi monitorare il tasso di copertura e di completamento, e inviare reminder a chi non ha ancora risposto.',
          },
          slide5: {
            title: 'Dai uno sguardo ai risultati',
            description:
              'Accedi alla dashboard per visualizzare i dati aggregati: punteggi medi dell’organizzazione e panoramica per dipartimento. Troverai valori medi (scala 0-7) sulle 4 hard skills, distribuzioni per livello e insight sui punti di forza e le aree di miglioramento. ',
          },
        },
      },
    },
    hardSkills: {
      title: 'Il tuo questionario Hard Skills sta arrivando!',
      description:
        'Stiamo preparando uno strumento per valutare le tue competenze tecniche. \nPresto potrai misurare le tue Hard Skills proprio come fai con le Soft Skills!',
      ctaLabel: 'Contattaci per sapere di più',
    },
    simulate: {
      title: 'Simulazione assessment',
      subtitle:
        "Prova la compilazione del questionario per vivere in prima persona l'esperienza dei tuoi dipendenti.",
      goBack: '{{templateName}} assessment',
      survey: {
        next: 'Avanti',
        back: 'Indietro',
        finish: 'Termina simulazione',
      },
      intro: {
        title: 'Simulazione {{templateName}} assessment',
        description:
          "Con la simulazione del {{templateName}} assessment puoi vivere in prima persona l'esperienza dei tuoi collaboratori: compila il questionario, esplora le sezioni e ottieni un esempio di profilo di {{templateName}}.\n\nRicorda che i dati della simulazione non vengono salvati e puoi ripeterla tutte le volte che vuoi. Per generare il tuo profilo ufficiale, dovrai censire la tua anagrafica e compilare il questionario come dipendente o manager.",
      },
      results: {
        title: 'Ecco il risultato della simulazione!',
        description:
          'Hai completato la simulazione e questo è il risultato delle tue {{templateName}}.',
        insights: {
          proTitle: 'Punti di forza',
          conTitle: 'Aree di miglioramento',
        },
      },
    },
  },
};
